"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.openExternalBrowserWhenLineIab = exports.showBlockerWhenIab = void 0;
var jsx_runtime_1 = require("preact/jsx-runtime");
var detect_inapp_1 = __importDefault(require("@qubic-js/detect-inapp"));
var preact_1 = require("preact");
var constant_1 = require("./constant");
var LeaveInAppBrowserModal_1 = __importDefault(require("./LeaveInAppBrowserModal"));
function showBlockerWhenIab(options) {
    var inapp = new detect_inapp_1.default(navigator.userAgent || navigator.vendor || window.opera);
    if (inapp.isInApp && !document.getElementById(constant_1.LEAVE_IAB_MODAL_ID)) {
        var createdRootDiv = document.createElement('div');
        document.body.appendChild(createdRootDiv);
        (0, preact_1.render)((0, jsx_runtime_1.jsx)(LeaveInAppBrowserModal_1.default, { options: options, inApp: inapp }), createdRootDiv);
    }
}
exports.showBlockerWhenIab = showBlockerWhenIab;
var PARAM_OPEN_EXTERNAL_BROWSER = 'openExternalBrowser';
function openExternalBrowserWhenLineIab() {
    var inapp = new detect_inapp_1.default(navigator.userAgent || navigator.vendor || window.opera);
    if (inapp.isInApp && inapp.browser === 'line' && typeof window !== 'undefined') {
        var url = new URL(window.location.href);
        if (url.searchParams.get(PARAM_OPEN_EXTERNAL_BROWSER) === '1') {
            return;
        }
        url.searchParams.set(PARAM_OPEN_EXTERNAL_BROWSER, '1');
        window.location.href = url.toString();
    }
}
exports.openExternalBrowserWhenLineIab = openExternalBrowserWhenLineIab;
